import {
    faAngleDown,
    faArrowUp,
    faBed,
    faCaretDown,
    faCircleCheck,
    faEllipsisVertical,
    faHouse
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import React from "react";
import { Col, Container, Dropdown, Image, Row } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import { Circle, Edit_2, Eye_2, GirlImg, Icon_Four, Icon_One, Icon_Three, Icon_Two, ImgHos, Loc_Icon, Mail_Icon, SplashLogo } from "../../../../../assets/images";
import * as Constants from "../../../../Helper/constants/constants";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import store from "../../../../../redux/store";
import { setDrawer } from "../../../../../redux/actions/users";

ChartJS.register(ArcElement, Tooltip, Legend);

const DashboardSuperAdmin = () => {

    const data = {
        datasets: [
            {
                data: [76, 24,],
                pointBackgroundColor: 'white',
                backgroundColor: (context) => {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;
                    if (!chartArea) {
                        return null
                    }
                    if (context.dataIndex === 0) {
                        return getGradient(chart);
                    }
                    if (context.dataIndex === 1) {
                        return getGradient_two(chart);
                    }
                    else {
                        return '#ED7932';
                    }
                }
            },
        ],
    };
    function getGradient(chart) {
        const { ctx, chartArea: { top, bottom, left, right } } = chart;
        const gradientSegment = ctx.createLinearGradient(left, 0, right, 0);
        gradientSegment.addColorStop(1, '#7367F0');
        gradientSegment.addColorStop(0.004, '#CE9FFC');
        gradientSegment.addColorStop(1, '#7367F0');
        return gradientSegment;
    }
    function getGradient_two(chart) {
        const { ctx, chartArea: { top, bottom, left, right } } = chart;
        const gradientSegment = ctx.createLinearGradient(left, 0, right, 0);
        gradientSegment.addColorStop(1, '#FA742B');
        gradientSegment.addColorStop(0.004, '#FFE985');
        gradientSegment.addColorStop(1, '#FA742B');
        return gradientSegment;
    }

    const handleDrawer = async (e) => {
        await store.dispatch(setDrawer(false));
    }

    return (
        <div className="dashboard_superadmin">
            <WithoutImageHeader
                header={Constants.DASHBOARD}
                lefticon='menu'
            />
            <Container onClick={() => handleDrawer()}>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="dashboard_logo_area">
                            <div className="logo_main_area">
                                <div className="left_area">
                                    <div className="img_logo">
                                        <Image src={SplashLogo} alt="..." />
                                    </div>
                                </div>
                                <div className="right_area">
                                    <div className="dropdown_area">
                                        <Dropdown>
                                            <Dropdown.Toggle id="dropdown-basic">
                                                Oxford Hospital
                                                <div className="icon down_icon ms-4">
                                                    <FontAwesomeIcon
                                                        icon={faAngleDown}
                                                    />
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item href="javscript:;">
                                                    Indraprastha Apollo Hospital
                                                </Dropdown.Item>
                                                <Dropdown.Item href="javscript:;">
                                                    Fortis Escorts Hospital
                                                </Dropdown.Item>
                                                <Dropdown.Item href="javscript:;">
                                                    Manipal Hospitals
                                                </Dropdown.Item>
                                                <Dropdown.Item href="javscript:;">
                                                    Medanta Hospital
                                                </Dropdown.Item>
                                                <Dropdown.Item href="javscript:;">
                                                    Narayana Health Hospital
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                            </div>
                            <div className="information_area">
                                <div className="left_info">
                                    <h6>Oxford Hospital</h6>
                                    <div className="inner_info_area space_mb">
                                        <div className="left_area">
                                            <div className="img_icon">
                                                <Image src={Mail_Icon} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <p>info@oxfordhospital.co.in</p>
                                        </div>
                                    </div>
                                    <div className="inner_info_area">
                                        <div className="left_area">
                                            <div className="img_icon">
                                                <Image src={Loc_Icon} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <p>305, Lajpat Nagar, Near Nakodar Chowk, Jalandhar (144 001) PB, India</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="right_info">
                                    <div className="img_area">
                                        <Image src={ImgHos} alt="..." />
                                    </div>
                                </div>
                            </div>
                            <div className="box_contain">
                                <Row>
                                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                        <div className="box_area">
                                            <div className="top_area">
                                                <div className="top_left">
                                                    <a href="javascript:;">
                                                        <div className="user_area">
                                                            <div className="img_area">
                                                                <img src={Icon_One} alt="..." />
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="top_right">
                                                    <div className="arrow_area">
                                                        <FontAwesomeIcon icon={faArrowUp} className="icon" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="middle">
                                                <h4>128</h4>
                                            </div>
                                            <div className="bottom_area">
                                                <p>Total Active Patients</p>
                                            </div>
                                            <div className="circle_area">
                                                <Image src={Circle} alt="..." />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                        <div className="box_area">
                                            <div className="top_area">
                                                <div className="top_left">
                                                    <a href="javascript:;">
                                                        <div className="user_area">
                                                            <div className="img_area">
                                                                <img src={Icon_Two} alt="..." />
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="top_right">
                                                    <div className="arrow_area">
                                                        <FontAwesomeIcon icon={faArrowUp} className="icon" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="middle">
                                                <h4>754</h4>
                                            </div>
                                            <div className="bottom_area">
                                                <p>Critical Patients</p>
                                            </div>
                                            <div className="circle_area">
                                                <Image src={Circle} alt="..." />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                        <div className="box_area">
                                            <div className="top_area">
                                                <div className="top_left">
                                                    <a href="javascript:;">
                                                        <div className="user_area">
                                                            <div className="img_area">
                                                                <img src={Icon_Three} alt="..." />
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="top_right">
                                                    <div className="arrow_area">
                                                        <FontAwesomeIcon icon={faArrowUp} className="icon" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="middle">
                                                <h4>200</h4>
                                            </div>
                                            <div className="bottom_area">
                                                <p>Patients Admitted</p>
                                            </div>
                                            <div className="circle_area">
                                                <Image src={Circle} alt="..." />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                        <div className="box_area">
                                            <div className="top_area">
                                                <div className="top_left">
                                                    <a href="javascript:;">
                                                        <div className="user_area">
                                                            <div className="img_area">
                                                                <img src={Icon_Four} alt="..." />
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="top_right">
                                                    <div className="arrow_area">
                                                        <FontAwesomeIcon icon={faArrowUp} className="icon" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="middle">
                                                <h4>754</h4>
                                            </div>
                                            <div className="bottom_area">
                                                <p>Patients Discharged </p>
                                            </div>
                                            <div className="circle_area">
                                                <Image src={Circle} alt="..." />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="average_main_area">
                                <div className="left_average_area">
                                    <h5>Task Overview</h5>
                                    <div className="text_area">
                                        <p>Today‘s Tasks - 100</p>
                                    </div>
                                    <div className="content_text space_text">
                                        <div className="left_box">
                                            <div className="box_contain"></div>
                                        </div>
                                        <div className="right_text">
                                            <p>Completed Task: 76</p>
                                        </div>
                                    </div>
                                    <div className="content_text">
                                        <div className="left_box">
                                            <div className="box_contain task"></div>
                                        </div>
                                        <div className="right_text">
                                            <p>Pending Task: 24 </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="right_average_area">
                                    <div className="dropdown_area">
                                        <Dropdown>
                                            <Dropdown.Toggle id="dropdown-basic">
                                                Yesterday
                                                <div className="icon down_icon ms-4">
                                                    <FontAwesomeIcon icon={faCaretDown} />
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item href="javscript:;">
                                                    Monday
                                                </Dropdown.Item>
                                                <Dropdown.Item href="javscript:;">
                                                    Tuesday
                                                </Dropdown.Item>
                                                <Dropdown.Item href="javscript:;">
                                                    abc
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className="circle_percentage">
                                        <Doughnut data={data} className="circle_part" />
                                    </div>
                                </div>
                            </div>
                            <div className="patient_admit_area">
                                <div className="title">
                                    <h4>Patient's Admitted Today: 50</h4>
                                </div>
                                <div className="date_area">
                                    <div className="left_date">
                                        <p>12 June, 2023</p>
                                    </div>
                                    <div className="right_date">
                                        <a href="javascript:;" className="btn btn-primary">View All</a>
                                    </div>
                                </div>
                                <div className="patient_main_area">
                                    <div className="left_main">
                                        <div className="text">
                                            <p>06:00 PM </p>
                                        </div>
                                        <div className="check_icon">
                                            <FontAwesomeIcon icon={faCircleCheck} />
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <a href="javascript:;">
                                            <div className="patient_info_area">
                                                <div className="left_info_area">
                                                    <div className="img_girl">
                                                        <Image src={GirlImg} alt='...' />
                                                    </div>
                                                </div>
                                                <div className="right_info_area">
                                                    <div className="patient_name_area">
                                                        <div className="left_area">
                                                            <h6>Patient Name</h6>
                                                            <div className="text">
                                                                <p>Cardiology</p>
                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <div className="disease_area">
                                                                <div className="left_disease">
                                                                    <p>Disease Heading</p>
                                                                    <div className="list_area">
                                                                        <ul>
                                                                            <li>
                                                                                <div className="text_icon">
                                                                                    <FontAwesomeIcon icon={faBed} className="icon" />Bed #05
                                                                                </div>
                                                                            </li>
                                                                            <li>
                                                                                <div className="text_icon">
                                                                                    <FontAwesomeIcon icon={faHouse} className="icon" />Room #05
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                                <div className="right_disease">
                                                                    {/* <div className="icon_dots">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </div> */}
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                            <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item href="javascript:;">
                                                                                View
                                                                                <Image src={Eye_2} alt="..." className="image_area" />
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Item href="javascript:;">
                                                                                Edit 
                                                                                <Image src={Edit_2} alt="..." className="image_area" />
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="patient_main_area">
                                    <div className="left_main">
                                        <div className="text">
                                            <p>06:00 PM </p>
                                        </div>
                                        <div className="check_icon">
                                            <FontAwesomeIcon icon={faCircleCheck} />
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <a href="javascript:;">
                                            <div className="patient_info_area">
                                                <div className="left_info_area">
                                                    <div className="img_girl">
                                                        <Image src={GirlImg} alt='...' />
                                                    </div>
                                                </div>
                                                <div className="right_info_area">
                                                    <div className="patient_name_area">
                                                        <div className="left_area">
                                                            <h6>Patient Name</h6>
                                                            <div className="text">
                                                                <p>Cardiology</p>
                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <div className="disease_area">
                                                                <div className="left_disease">
                                                                    <p>Disease Heading</p>
                                                                    <div className="list_area">
                                                                        <ul>
                                                                            <li>
                                                                                <div className="text_icon">
                                                                                    <FontAwesomeIcon icon={faBed} className="icon" />Bed #05
                                                                                </div>
                                                                            </li>
                                                                            <li>
                                                                                <div className="text_icon">
                                                                                    <FontAwesomeIcon icon={faHouse} className="icon" />Room #05
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                                <div className="right_disease">
                                                                    {/* <div className="icon_dots">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                </div> */}
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                            <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item href="javascript:;">
                                                                                View
                                                                                <Image src={Eye_2} alt="..." className="image_area" />
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Item href="javascript:;">
                                                                                Edit 
                                                                                <Image src={Edit_2} alt="..." className="image_area" />
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="patient_main_area">
                                    <div className="left_main">
                                        <div className="text">
                                            <p>06:00 PM </p>
                                        </div>
                                        <div className="check_icon">
                                            <FontAwesomeIcon icon={faCircleCheck} />
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <a href="javascript:;">
                                            <div className="patient_info_area">
                                                <div className="left_info_area">
                                                    <div className="img_girl">
                                                        <Image src={GirlImg} alt='...' />
                                                    </div>
                                                </div>
                                                <div className="right_info_area">
                                                    <div className="patient_name_area">
                                                        <div className="left_area">
                                                            <h6>Patient Name</h6>
                                                            <div className="text">
                                                                <p>Cardiology</p>
                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <div className="disease_area">
                                                                <div className="left_disease">
                                                                    <p>Disease Heading</p>
                                                                    <div className="list_area">
                                                                        <ul>
                                                                            <li>
                                                                                <div className="text_icon">
                                                                                    <FontAwesomeIcon icon={faBed} className="icon" />Bed #05
                                                                                </div>
                                                                            </li>
                                                                            <li>
                                                                                <div className="text_icon">
                                                                                    <FontAwesomeIcon icon={faHouse} className="icon" />Room #05
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                                <div className="right_disease">
                                                                    {/* <div className="icon_dots">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                </div> */}
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                            <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item href="javascript:;">
                                                                                View
                                                                                <Image src={Eye_2} alt="..." className="image_area" />
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Item href="javascript:;">
                                                                                Edit 
                                                                                <Image src={Edit_2} alt="..." className="image_area" />
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div >
    );
};

export default DashboardSuperAdmin;
